<template>
  <form class="project-mutate-theme" @submit.prevent="$emit('submit')">
    <Card class="project-mutate-theme__inputs">
      <FieldRenderer v-for="item in fields.default" :item="item" :value="value" />

      <CustomFields
        v-model="value.customFields"
        :schema="customFieldSchemas"
        :data="data"
        :placement="['theme', 'project:theme']"
        data-field="custom-fields"
        :validator="validator"
        validator-prefix="customFields"
        :disabledFields="disabledFields"
      >
        <template v-for="item in fields.slots" v-slot:[item.slotKey]>
          <FieldRenderer :item="item" :value="value" />
        </template>
      </CustomFields>
    </Card>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'

import Card from '@/components/Card'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Project/StepsFields/FieldRenderer.vue'

const meta = {
  order: 2,
  id: 'theme',
  label: i18n.t('designAndTheme'),
  icon: ['fal', 'palette'],
}

export { meta }
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('Project', {
      item(state) {
        return state.item && Object.keys(state.item).length ? state.item : this.data
      },
    }),
    disabledFields() {
      return this.$path('item.metadata.disabledFields.project')
    },
  },
  components: {
    Card,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.project-mutate-theme {
  $cols: 2;

  &__load-trigger {
    grid-column-end: span 2;
    text-align: center;
    margin-bottom: 2rem;
  }

  &__theme-upgrade-modal {
    .card {
      max-width: 700px;
      min-width: 400px;

      &__title {
        border-bottom: 1px solid var(--border-color);
        padding-bottom: 1rem;
      }
    }
  }
  &__items {
    grid-column-end: span 2;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem;
    margin-bottom: 2rem;

    .theme-card:not(.theme-card--shrink) {
      grid-column-end: span 2;
      display: grid;
      grid-template-columns: 0.7fr 1fr;
      .link-card {
        &__image {
          padding-top: 0.5rem;
          background-color: $beige;
          aspect-ratio: 1.57/1;
        }
      }
      &.theme-card--active {
        background-color: hsl(var(--secondary-h), var(--secondary-s), 92%);
      }
    }

    .theme-card--shrink.theme-card {
      .link-card {
        &__image {
          aspect-ratio: 4/2;
          border-radius: inherit;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          img {
            transform: translate(0, 20px);
          }
        }

        &__content {
          padding: 1rem;
          h3 {
            margin: 0;
          }
        }
      }
    }
  }

  &__inputs {
    max-width: 900px;
    margin: auto;

    .card__content {
      display: grid;
      grid-template-columns: repeat($cols, 1fr);
      grid-gap: 1rem;
      align-items: baseline;

      [data-field='site-settings'],
      [data-field='theme'] {
        grid-column-end: span 2;
      }
    }
  }

  &__preview {
    font-size: 0.8em;
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
